<template>
  <div class="subscriptionPage-detail">
    <div v-if="showTips" class="tips">当前二维码无效，请检查</div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import axios from 'axios'
import { Toast } from "vant";

@Component({
  created() {
    this.getPayUrl()
  },
  data(){
    return {
      showTips:false
    }
  },
  methods: {
    async getPayUrl() {
      const key = this.$route.query.key
      let info = await this.getParams(key)

      let params = JSON.parse(info)

      axios.get(`/apis/moyin-account/v1/subscribe/order/info?${this.__fParams(params)}`).then(res => {
        if (res.data.code !== 200) return Toast(res.data.message);
        window.location.replace(res.data.data.data)
        
        ap.popWindow();
        setTimeout(()=>{
          this.showTips = true
        },500)
      }).catch(err => {
        Toast(res.data.message);
        this.showTips = true
      })
    },
    async getParams(key){
      let res = await axios.get(`/apis/moyin-account/orderParam/getParam?key=${key}`)
      return res.data.data
    },
    __fParams(params) {
      if (!params || !Object.keys(params).length) return ''
      let paramsStr = ''
      for (let i in params) {
        paramsStr += `${i}=${params[i]}&`
      }
      return paramsStr.substr(0, paramsStr.length - 1)
    }
  }
})
export default class subscriptionPage extends Vue { }

</script>

<style lang="less" scoped>
.subscriptionPage-detail {
  width: 100vw;
  height: 100vh;
  .tips {
    text-align: center;
    margin-top: 64px;
    font-size: 32px;
    font-family: HarmonyOS_Sans_SC_Medium;
  }
}
</style>